<template>
  <FieldGrid
    :fields="processedGrid"
    :dv="dv"
    :cell-slots="$slots"
    :validation-errors="validationErrors"
  />
</template>

<script>
import { computed } from 'vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'
import {
  CUSTOM_PROPERTIES,
  expandCustomProperties,
} from '../../shared/fieldConstants.js'

export { CUSTOM_PROPERTIES }

const DEFAULT_FIELDS = [
  ['id', 'code'],
  ['name'],
  ['primary_project'],
  ['sample_status', 'sample_qc'],
  ['organism', 'material_type'],
  ['produced'],
  ['stock_locations'],
  ['stock_locations_breadcrumb'],
  CUSTOM_PROPERTIES,
  ['description'],
  ['protocol_list'],
]

export default {
  name: 'SampleDescriptionGrid',
  components: {
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
    fields: { type: Array, default: () => DEFAULT_FIELDS },
    validationErrors: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const processedGrid = computed(() =>
      expandCustomProperties(props.fields, props.dv.customProperties),
    )

    return { processedGrid }
  },
}
</script>
